import { render, staticRenderFns } from "./TransactionRoomBooking.vue?vue&type=template&id=152b1ce4&scoped=true"
import script from "./TransactionRoomBooking.vue?vue&type=script&lang=js"
export * from "./TransactionRoomBooking.vue?vue&type=script&lang=js"
import style0 from "./TransactionRoomBooking.vue?vue&type=style&index=0&id=152b1ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b1ce4",
  null
  
)

export default component.exports